<app-material-table
  [fields]="fields"
  [schema]="schema"
  [data]="data"
  [fieldsToDisplay]="fieldsToDisplay"
  [dataSource]="dataSource">
</app-material-table>
